const vendorLabelToVendorNameMap: Record<Brand, string> = {
  "2degrees": "2Degrees",
  "app-sinch": "Dashboard",
  directSMS: "DirectSMS",
  etxt: "eTXT",
  messagenet: "MessageNet",
  mm: "MessageMedia",
  mobipost: "Mobipost",
  simpletexting: "SimpleTexting",
  sincheu: "Dashboard",
  smsb: "SMSBroadcast",
  smscentral: "SMSCentral",
  streetdata: "Streetdata",
  tpgtelecom: "TPGTelecom",
  vodanz: "VodaNZ",
  wholesale: "WholesaleSMS",
  messagestudio: "MessageStudio",
  "notify-now": "NotifyNow",
};

export const getVendorId = (): string | null => {
  const vendor = window.VENDOR_LABEL;
  if (!vendor) return null;

  const vendorId = vendorLabelToVendorNameMap[vendor];
  if (!vendorId) return null;

  return vendorId;
};
